import React from 'react';

import "./assets/scss/themes.scss";

import Route from './Routes/index';

const App = () => {
  return (
    <React.Fragment>
      <Route />
    </React.Fragment>
  );
}

export default App;
